import React from 'react';
import { ArrowRight } from 'lucide-react';
const HowItWorksSection = () => {
  const handleStartClick = e => {
    e.preventDefault();
    // Rolar diretamente para o topo sem delay
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const steps = [{
    number: '01',
    title: 'Insira sua marca',
    description: 'Forneça o nome da sua marca e a URL do seu site para iniciar a análise semântica.'
  }, {
    number: '02',
    title: 'Concorrentes',
    description: 'Identifique seus principais concorrentes para comparação e benchmark de atributos de marca.'
  }, {
    number: '03',
    title: 'Atributos',
    description: 'Nossa IA analisa como sua marca e concorrentes são percebidos em relação a atributos-chave nas LLMs.'
  }, {
    number: '04',
    title: 'Relatório completo',
    description: 'Receba insights detalhados sobre posicionamento semântico e estratégias para melhorar sua presença nas IAs.'
  }];
  return <section className="py-16 bg-gradient-to-b from-white to-blue-50" data-id="element-616">
      <div className="container px-4 mx-auto sm:px-6 lg:px-8" data-id="element-617">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-618">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-619">
            Como funciona
          </h2>
          <p className="mt-4 text-lg text-gray-600" data-id="element-620">
            Um processo estruturado para otimizar a presença da sua marca nas
            respostas de LLMs
          </p>
        </div>
        <div className="relative" data-id="element-621">
          <div className="grid gap-8 md:grid-cols-4" data-id="element-622">
            {steps.map((step, index) => <div key={index} className="relative flex flex-col items-center" data-id="element-623">
                <div className="w-16 h-16 mb-6 flex items-center justify-center bg-[#1649ff] text-white text-xl font-bold rounded-full z-10" data-id="element-624">
                  {step.number}
                </div>
                <h3 className="mb-2 text-xl font-semibold text-gray-900 text-center" data-id="element-625">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-center" data-id="element-626">{step.description}</p>
                {index < steps.length - 1 && <div className="hidden md:block absolute top-8 -right-4 transform translate-x-1/2" data-id="element-627">
                    <ArrowRight className="w-6 h-6 text-gray-400" data-id="element-628" />
                  </div>}
              </div>)}
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-629">
          <button onClick={handleStartClick} className="inline-flex items-center px-6 py-3 text-white bg-[#1649ff] rounded-md hover:bg-blue-700 transition-colors" data-id="element-630">
            Comece agora <ArrowRight size={16} className="ml-2" data-id="element-631" />
          </button>
        </div>
      </div>
      {/* AI-themed decorative elements */}
      <div className="relative mt-16" data-id="element-632">
        <div className="absolute top-0 left-0 w-full" data-id="element-633">
          <div className="container px-4 mx-auto" data-id="element-634">
            <div className="grid grid-cols-6 gap-4" data-id="element-635">
              {[...Array(6)].map((_, i) => <div key={i} className="h-1 bg-[#1649ff]" style={{
              opacity: 0.1 + i * 0.05,
              transform: `scaleX(${0.5 + i * 0.1})`
            }} data-id="element-636"></div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default HowItWorksSection;